var totalScore = 0;
var percentScore = 0;
var scoredConnectedness = 0;
var scoredNURTITION = 0;
var scoredSTRESS = 0;
var scoredSUBSTANCE = 0;
var scoredRECOVERY = 0;
var scoredMOVEMENT = 0;

var totalSumRadio = 0;
document
  .getElementById("info-form")
  .addEventListener("submit", function (event) {
    event.preventDefault();
    stepIndex = 2;
    evaluateIndex();
  });
document
  .getElementById("radio-form")
  .addEventListener("submit", function (event) {
    event.preventDefault();
    let allAreFilled = true;
    document
      .getElementById("radio-form")
      .querySelectorAll("[required]")
      .forEach(function (i) {
        if (!allAreFilled) return;
        if (i.type === "radio") {
          let radioValueCheck = false;
          document
            .getElementById("radio-form")
            .querySelectorAll(`[name=${i.name}]`)
            .forEach(function (r) {
              if (r.checked) radioValueCheck = true;
            });
          allAreFilled = radioValueCheck;
          return;
        }
        if (!i.value) {
          allAreFilled = false;
          return;
        }
      });
    if (!allAreFilled) {
      alert("Fill all the fields");
      return;
    }
    const radioButtons = document.querySelectorAll(
      '#radio-form input[type="radio"]:checked'
    );
    totalSumRadio = 0;
    let sumByCategory = {};

    if (radioButtons) {
      radioButtons.forEach(function (radioButton) {
        const dataCategoryArray = JSON.parse(
          radioButton.getAttribute("data-category")
        );
        const value = parseInt(radioButton.value, 10);
        totalSumRadio += value;

        if (dataCategoryArray) {
          dataCategoryArray.forEach(function (category) {
            sumByCategory[category] = (sumByCategory[category] || 0) + value;
          });
        }
      });
    }
    if (sumByCategory?.CONNECTEDNESS) {
      scoredConnectedness = sumByCategory?.CONNECTEDNESS;
    }
    if (sumByCategory?.NURTITION) {
      scoredNURTITION = sumByCategory?.NURTITION;
    }
    if (sumByCategory?.STRESS) {
      scoredSTRESS = sumByCategory?.STRESS;
    }
    if (sumByCategory?.SUBSTANCE) {
      scoredSUBSTANCE = sumByCategory?.SUBSTANCE;
    }
    if (sumByCategory?.RECOVERY) {
      scoredRECOVERY = sumByCategory?.RECOVERY;
    }

    stepIndex = 3;
    evaluateIndex();
  });

var rangeScore;
document
  .getElementById("range-form")
  .addEventListener("submit", function (event) {
    event.preventDefault();
    var gender;
    const sexRadios = document.getElementsByName("sex");
    for (var i = 0; i < sexRadios.length; i++) {
      if (sexRadios[i].checked) {
        gender = sexRadios[i].value;
      }
    }
    rangeScore = 0;
    sliders = document.querySelectorAll(".slider");

    var timesSitdown = document.getElementById("times-sitdown");
    var trainingWorkouts = document.getElementById("training-workouts");
    var sweetenedDrinks = document.getElementById("sweetened-drinks");
    var drinkAlcoholDays = document.getElementById("drink-alcohol-days");
    var drinkAlcoholAmount = document.getElementById("drink-alcohol-amount");
    var snacksPerDay = document.getElementById("snacks-per-day");
    var sleepHours = document.getElementById("sleep-hours");
    var fruitServings = document.getElementById("fruit-servings");
    var sittingHours = document.getElementById("sitting-hour");
    var vegetableServings = document.getElementById("vegetable-servings");
    var cardioExercise = document.getElementById("cardio-exercise");
    var nutsAndSeeds = document.getElementById("nuts-and-seeds");
    var beansAndLegumes = document.getElementById("beans-and-legume");

    if (timesSitdown.value == "<1") {
      rangeScore = rangeScore + 0;
      scoredSTRESS = scoredSTRESS + 0;
    } else if (timesSitdown.value == "1") {
      rangeScore = rangeScore + 1;
      scoredSTRESS = scoredSTRESS + 0;
    } else {
      rangeScore = rangeScore + 0;
      scoredSTRESS = scoredSTRESS + 0;
    }

    if (trainingWorkouts.value == "<1") {
      rangeScore = rangeScore + 0;
      scoredMOVEMENT = scoredMOVEMENT + 0;
    } else if (trainingWorkouts.value == "1") {
      rangeScore = rangeScore + 1;
      scoredMOVEMENT = scoredMOVEMENT + 1;
    } else {
      rangeScore = rangeScore + 2;
      scoredMOVEMENT = scoredMOVEMENT + 2;
    }

    if (sweetenedDrinks.value == "<1") {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    } else {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    }

    if (gender == "female") {
      if (drinkAlcoholDays.value == "<1" || drinkAlcoholDays.value == "1") {
        rangeScore = rangeScore + 2;
        scoredSUBSTANCE = scoredSUBSTANCE + 2;
      } else {
        rangeScore = rangeScore + 0;
        scoredSUBSTANCE = scoredSUBSTANCE + 0;
      }
    }
    if (gender == "male") {
      if (
        drinkAlcoholDays.value == "<1" ||
        drinkAlcoholDays.value == "1" ||
        drinkAlcoholDays.value == "2"
      ) {
        rangeScore = rangeScore + 2;
        scoredSUBSTANCE = scoredSUBSTANCE + 2;
      } else {
        rangeScore = rangeScore + 0;
        scoredSUBSTANCE = scoredSUBSTANCE + 0;
      }
    }
    if (gender == "Female") {
      if (drinkAlcoholAmount.value == "<1" || drinkAlcoholAmount.value == "1") {
        rangeScore = rangeScore + 2;
        scoredSUBSTANCE = scoredSUBSTANCE + 2;
      } else {
        rangeScore = rangeScore + 0;
        scoredSUBSTANCE = scoredSUBSTANCE + 0;
      }
    }
    if (gender == "Male") {
      if (
        drinkAlcoholAmount.value == "<1" ||
        drinkAlcoholAmount.value == "1" ||
        drinkAlcoholAmount.value == "2"
      ) {
        rangeScore = rangeScore + 2;
        scoredSUBSTANCE = scoredSUBSTANCE + 2;
      } else {
        rangeScore = rangeScore + 0;
        x;
        scoredSUBSTANCE = scoredSUBSTANCE + 0;
      }
    }

    if (snacksPerDay.value == "<1") {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    } else {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    }

    if (
      sleepHours.value == "7" ||
      sleepHours.value == "8" ||
      sleepHours.value == "9"
    ) {
      rangeScore = rangeScore + 5;
      scoredRECOVERY = scoredRECOVERY + 5;
    } else if (
      sleepHours.value == "5" ||
      sleepHours.value == "6" ||
      sleepHours.value == "10+"
    ) {
      rangeScore = rangeScore + 3;
      scoredRECOVERY = scoredRECOVERY + 3;
    } else {
      rangeScore = rangeScore + 0;
      scoredRECOVERY = scoredRECOVERY + 0;
    }

    if (fruitServings.value == "2" || fruitServings.value == "3") {
      rangeScore = rangeScore + 2;
      scoredNURTITION = scoredNURTITION + 2;
    } else if (fruitServings.value == "1") {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    } else {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    }

    if (sittingHours.value == "9" || sittingHours.value == "10+") {
      rangeScore = rangeScore + 0;
      scoredMOVEMENT = scoredMOVEMENT + 0;
    } else if (sittingHours.value == "7" || sittingHours.value == "8") {
      rangeScore = rangeScore + 1;
      scoredMOVEMENT = scoredMOVEMENT + 1;
    } else {
      rangeScore = rangeScore + 3;
      scoredMOVEMENT = scoredMOVEMENT + 3;
    }

    if (vegetableServings.value == "1" || vegetableServings.value == "2") {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    } else if (vegetableServings.value == "<1") {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    } else {
      rangeScore = rangeScore + 3;
      scoredNURTITION = scoredNURTITION + 3;
    }

    if (
      nutsAndSeeds.value == "<1" ||
      nutsAndSeeds.value == "1" ||
      nutsAndSeeds.value == "2" ||
      nutsAndSeeds.value == "3" ||
      nutsAndSeeds.value == "4"
    ) {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    } else {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    }

    if (beansAndLegumes.value == "<1" || beansAndLegumes.value == "1") {
      rangeScore = rangeScore + 0;
      scoredNURTITION = scoredNURTITION + 0;
    } else {
      rangeScore = rangeScore + 1;
      scoredNURTITION = scoredNURTITION + 1;
    }

    if (cardioExercise.value == "<30min") {
      rangeScore = rangeScore + 0;
      scoredMOVEMENT = scoredMOVEMENT + 0;
    } else if (
      cardioExercise.value == "30min" ||
      cardioExercise.value == "45min"
    ) {
      rangeScore = rangeScore + 1;
      scoredMOVEMENT = scoredMOVEMENT + 1;
    } else if (cardioExercise.value == "1h") {
      rangeScore = rangeScore + 2;
      scoredMOVEMENT = scoredMOVEMENT + 2;
    } else if (cardioExercise.value == "1.5h") {
      rangeScore = rangeScore + 3;
      scoredMOVEMENT = scoredMOVEMENT + 3;
    } else if (cardioExercise.value == "2h") {
      rangeScore = rangeScore + 4;
      scoredMOVEMENT = scoredMOVEMENT + 4;
    } else {
      rangeScore = rangeScore + 5;
      scoredMOVEMENT = scoredMOVEMENT + 5;
    }
    stepIndex = 4;
    evaluateIndex();
    calculateResults(rangeScore);

    showResults();
  });

var calculateResults = function (rangeScore) {
  totalScore = totalSumRadio + rangeScore;

  document.getElementById("totalscore").innerHTML = totalScore;
  document.getElementById("substanceTotal").innerHTML = scoredSUBSTANCE;
  document.getElementById("connectednessTotal").innerHTML = scoredConnectedness;
  document.getElementById("recoveryTotal").innerHTML = scoredRECOVERY;
  document.getElementById("nutritionTotal").innerHTML = scoredNURTITION;
  document.getElementById("movementTotal").innerHTML = scoredMOVEMENT;
  document.getElementById("stressTotal").innerHTML = scoredSTRESS;

  percentScore = (totalScore / 60) * 100;
  var percentageClassElement = document.getElementById("percentageClass");
  if (percentScore >= 80 && percentScore <= 100) {
    percentageClassElement.innerHTML = "Excellent";
  } else if (percentScore >= 61 && percentScore <= 79) {
    percentageClassElement.innerHTML = "Above Average";
  } else if (percentScore >= 40 && percentScore <= 60) {
    percentageClassElement.innerHTML = "Average";
  } else if (percentScore >= 0 && percentScore <= 39) {
    percentageClassElement.innerHTML = "Below Average";
  }
  var remarksElement = document.getElementById("remarks");
  switch (true) {
    case percentScore >= 80 && percentScore <= 100:
      remarksElement.innerHTML =
        "Dein Ergebnis ist ausgezeichnet und zeigt, dass du außergewöhnliche Gesundheitsgewohnheiten hast. Wir sind sicher, dass Longenic eine großartige Ergänzung zu deinem Lebensstil ist.";
      break;
    case percentScore >= 61 && percentScore <= 79:
      remarksElement.innerHTML =
        "Dein Ergebnis ist über dem Durchschnitt und zeigt gute Gesundheitspraktiken an. Wir sind sicher, dass Longenic eine großartige Ergänzung zu deinem Lebensstil ist.";
      break;
    case percentScore >= 40 && percentScore <= 60:
      remarksElement.innerHTML =
        "Du hast einige großartige Gesundheitsgewohnheiten, obwohl es reichlich Gelegenheit gibt, deine Gesundheit zu verbessern. Wir sind sicher, dass Longenic eine großartige Ergänzung zu deinem Lebensstil ist.";
      break;
    case percentScore >= 0 && percentScore <= 39:
      remarksElement.innerHTML =
        "Dein Ergebnis liegt unter dem Durchschnitt und deutet darauf hin, dass es mehrere Bereiche in deinem Lebensstil gibt, die Aufmerksamkeit und Verbesserung erfordern. Wir sind sicher, dass Longenic eine großartige Ergänzung zu deinem Lebensstil ist.";
      break;
    default:
      remarksElement.innerHTML = "Invalid percentage score.";
  }
};

var showResults = function () {
  const ctx = document.getElementById("myChart");
  new Chart(ctx, {
    type: "polarArea",
    clip: 4,
    data: {
      labels: [
        "Substanzgebrauch",
        "Bewegung",
        "Ernährung",
        "Erholung",
        "Verbundenheit",
        "Stress",
      ],
      datasets: [
        {
          label: "Lifestyle Score",
          data: [
            scoredSUBSTANCE,
            scoredMOVEMENT,
            scoredNURTITION,
            scoredRECOVERY,
            scoredConnectedness,
            scoredSTRESS,
          ],
          backgroundColor: [
            "#ff6384",
            "#FFB300",
            "#8bc34a",
            "#90CAF9",
            "#ce93d8",
            "#e57373",
          ],
        },
      ],
    },
    options: {
      scales: {
        r: {
          ticks: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: function (context) {
              const value = context.formattedValue;
              return `${value}`;
            },
          },
        },
      },
    },
  });

  initializePdfTemplate();

  download = document.getElementById("download");
  download.addEventListener(
    "click",
    function () {
      try { 
        if (
          typeof window.jspdf === "undefined" &&
          typeof jsPDF === "undefined"
        ) {
          console.log("jsPDF library is not loaded. Please check your script tags.");
          return;
        }

        if (typeof html2canvas === "undefined") {
          console.log(
            "html2canvas library is not loaded. Please check your script tags."
          );
          return;
        } 
        
        const downloadBtn = document.getElementById("download");  
        downloadBtn.disabled = true;
 
        updatePdfTemplate();
 
        const template = document.getElementById("pdfTemplate");
        template.style.display = "block";
        template.style.position = "absolute";
        template.style.left = "-9999px";  
        template.style.top = "0";
 
        setTimeout(() => { 
          html2canvas(template, {
            scale: 1.5,  
            useCORS: true,
            allowTaint: true,
            backgroundColor: "#ffffff",
            logging: false,
            width: template.offsetWidth,
            height: template.offsetHeight,
            onclone: function (clonedDoc) {
              const clonedTemplate = clonedDoc.getElementById("pdfTemplate");
              if (clonedTemplate) {
                clonedTemplate.style.display = "block";
                clonedTemplate.style.position = "static";
                clonedTemplate.style.left = "auto";
                clonedTemplate.style.top = "auto";
              }
            },
          })
            .then((canvas) => {
              try {
                const imgData = canvas.toDataURL("image/png", 0.8); 
                let pdf;
                if (typeof jsPDF !== "undefined") {
                  pdf = new jsPDF("p", "mm", "a4");
                } else {
                  console.log("jsPDF library is not available");
                  return;
                }

                const imgWidth = 210; // A4 width in mm
                const pageHeight = 297; // A4 height in mm
                const imgHeight = (canvas.height * imgWidth) / canvas.width;

                let heightLeft = imgHeight;
                let position = 0;

                pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;

                while (heightLeft >= 0) {
                  position = heightLeft - imgHeight;
                  pdf.addPage();
                  pdf.addImage(
                    imgData,
                    "PNG",
                    0,
                    position,
                    imgWidth,
                    imgHeight
                  );
                  heightLeft -= pageHeight;
                }
 
                pdf.save("lifestyle-assessment-results.pdf"); 
              } catch (pdfError) {
                console.error("PDF generation error:", pdfError.message); 
              } finally { 
                template.style.display = "none";
                template.style.position = "static";
                template.style.left = "auto"; 
                downloadBtn.disabled = false;
              }
            })
            .catch((canvasError) => {
              console.error("Canvas generation error:", canvasError); 
              fallbackPdfGeneration(); 
              template.style.display = "none";
              template.style.position = "static";
              template.style.left = "auto"; 
              downloadBtn.disabled = false;
            });
        }, 100);
      } catch (error) {
        console.error("General error:", error);  
        const downloadBtn = document.getElementById("download");
        downloadBtn.textContent = "Download PDF";
        downloadBtn.disabled = false;
      }
    },
    false
  );
};
 
function fallbackPdfGeneration() {
  try {
    const canvas = document.getElementById("myChart");
    const imgData = canvas.toDataURL("image/png", 1.0);

    // Create PDF with fallback method
    let pdf;
    if (typeof window.jspdf !== "undefined") {
      pdf = new window.jspdf.jsPDF("p", "mm", "a4");
    } else if (typeof jsPDF !== "undefined") {
      pdf = new jsPDF("p", "mm", "a4");
    } else {
      alert("PDF library not available");
      return;
    }

    // Add title
    pdf.setFontSize(18);
    pdf.text("Lifestyle Medicine Assessment", 105, 20, { align: "center" });

    // Add score
    pdf.setFontSize(12);
    const totalScore = window.totalScore || 0;
    pdf.text(`Overall Lifestyle Score: ${totalScore}/60`, 20, 40);

    // Add percentage if available
    const percentageElement = document.getElementById("percentageClass");
    if (percentageElement) {
      pdf.text(percentageElement.textContent, 20, 50);
    }

    // Add chart
    pdf.text("Individual Domain Scores:", 20, 70);
    pdf.addImage(imgData, "PNG", 20, 80, 170, 120);

    // Add remarks if available
    const remarksElement = document.getElementById("remarks");
    if (remarksElement) {
      const remarks = pdf.splitTextToSize(remarksElement.textContent, 170);
      pdf.text(remarks, 20, 220);
    }

    pdf.save("lifestyle-assessment-basic.pdf");
    alert("Basic PDF generated successfully!");
  } catch (error) {
    console.error("Fallback PDF error:", error);
    alert("Unable to generate PDF. Please try refreshing the page.");
  }
}

// PDF Template HTML (simplified for better compatibility)
const pdfTemplateHTML = `
<div id="pdfTemplate" class="pdf-template" style="display: none;">
    <div class="pdf-header">
        <h1>Lifestyle Medicine Assessment</h1>
    </div>
    
    <div class="pdf-score-section">
        <h2>Overall Assessment</h2>
        <div class="pdf-score-value" id="pdfScore">Overall Lifestyle Score: 45/60</div>
        <div class="pdf-percentage" id="pdfPercentage">Good Progress - 75%</div>
    </div>
    
    <div class="pdf-remarks-section">
        <h3>Assessment Remarks</h3>
        <div id="pdfRemarks">Your lifestyle assessment shows good progress.</div>
    </div>
    
    <div class="pdf-content-container">
        <div class="pdf-chart-container">
            <h3>Individual Domain Scores</h3>
            <div id="chartImageContainer">
                <!-- Chart image will be inserted here -->
            </div>
        </div>
        
        <div class="pdf-stats-container"> 
            <div id="statsContainer" class="result">
                <!-- Stats will be inserted here -->
            </div>
        </div>
    </div>
</div>
`;

// Simplified PDF Template CSS for better compatibility
const pdfStyles = `
<style id="pdfTemplateStyles">
.pdf-template {
    width: 794px;
    background: white;
    padding: 40px;
    font-family: 'Poppins, sans-serif' !important;
    box-sizing: border-box;
    color: #333;
}

.pdf-header h1 {
    text-align: center;
    color:rgb(49, 49, 49);
    font-size: 26px;
    margin-bottom: 30px; 
    padding-bottom: 10px;
}

.pdf-score-section {
    background: #ededed;
    padding: 16px;
    border-radius: 5px;
    margin: 20px 0; 
}

.pdf-score-section h2 {
    margin-top: 0;
    font-size: 18px;
    margin-bottom: 15px;
}

.pdf-score-value {
    font-size: 20px;
    font-weight: bold; 
    margin: 10px 0;
}

.pdf-percentage {
    font-size: 14px;
    color: #666;
}

.pdf-remarks-section {
    margin: 20px 0; 
}

.pdf-remarks-section h3 {
    margin-top: 0;
    font-size: 16px;
    margin-bottom: 10px;
}

.pdf-content-container {
    display: flex;
    gap: 20px;
    margin: 40px 0;
}

.pdf-chart-container {
    flex: 1;
    text-align: center;
}

.pdf-chart-container h3 {
    margin-bottom: 15px;
    font-size: 16px;
}

.pdf-stats-container {
    flex: 1; 
    padding: 20px; 
}

.pdf-stats-container h3 {
    margin-top: 0;
    margin-bottom: 15px;
    font-size: 16px;
}

.chart-image {
    max-width: 100%;
    height: auto;  
    background: white;
}

.domain-stats {
    display: block;
}

.domain-item {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid #eee;
}

.domain-item:last-child {
    border-bottom: none;
}

.domain-label {
    font-weight: 500;
    color: #495057;
}

.domain-score {
    font-weight: bold; 
}

.result-listing {
    list-style: none;
    padding: 0;
    margin: 0;
}

.result-listing li {
    padding: 8px 0;
    border-bottom: 1px solid #e9ecef;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.result-listing li:last-child {
    border-bottom: none;
}
</style>
`;

function initializePdfTemplate() {
    debugger;
  if (!document.getElementById("pdfTemplateStyles")) {
    document.head.insertAdjacentHTML("beforeend", pdfStyles);
  }
  if (!document.getElementById("pdfTemplate")) {
    document.body.insertAdjacentHTML("beforeend", pdfTemplateHTML);
  }
}

// Update PDF template with current data
function updatePdfTemplate() {
  const totalScore = window.totalScore || 0;
  const percentageElement = document.getElementById("percentageClass");
  const remarksElement = document.getElementById("remarks");

  const percentageClass = percentageElement
    ? percentageElement.innerHTML
    : "Assessment Complete";
  const remarks = remarksElement
    ? remarksElement.innerHTML
    : "Assessment completed successfully.";
 
  document.getElementById(
    "pdfScore"
  ).textContent = `Overall Lifestyle Score: ${totalScore}/60`;
  document.getElementById("pdfPercentage").innerHTML = percentageClass;
  document.getElementById("pdfRemarks").innerHTML = remarks;
 
  const canvas = document.getElementById("myChart");
  const chartImage = canvas.toDataURL("image/png", 1.0);
 
  const chartContainer = document.getElementById("chartImageContainer");
  chartContainer.innerHTML = `<img src="${chartImage}" class="chart-image" alt="Lifestyle Assessment Chart">`;
 
  const statsContainer = document.getElementById("statsContainer");
  const originalStats = document.querySelector(".result-listing");
  debugger;
  if (originalStats) { 
    statsContainer.innerHTML = originalStats.outerHTML;
  } else { 
    const domainStats = `
            <div class="domain-stats">
                <div class="domain-item">
                    <span class="domain-label">Substance:</span>
                    <span class="domain-score">${
                      window.scoredSUBSTANCE || 0
                    }/10</span>
                </div>
                <div class="domain-item">
                    <span class="domain-label">Movement:</span>
                    <span class="domain-score">${
                      window.scoredMOVEMENT || 0
                    }/10</span>
                </div>
                <div class="domain-item">
                    <span class="domain-label">Nutrition:</span>
                    <span class="domain-score">${
                      window.scoredNURTITION || 0
                    }/10</span>
                </div>
                <div class="domain-item">
                    <span class="domain-label">Recovery:</span>
                    <span class="domain-score">${
                      window.scoredRECOVERY || 0
                    }/10</span>
                </div>
                <div class="domain-item">
                    <span class="domain-label">Connectedness:</span>
                    <span class="domain-score">${
                      window.scoredConnectedness || 0
                    }/10</span>
                </div>
                <div class="domain-item">
                    <span class="domain-label">Stress:</span>
                    <span class="domain-score">${
                      window.scoredSTRESS || 0
                    }/10</span>
                </div>
            </div>
        `;
    statsContainer.innerHTML = domainStats;
  }
}
var isSliderloaded = false;
document.addEventListener("DOMContentLoaded", function () {
  buildStepper();
});

var setPage = function () {
  const elements = document.querySelectorAll(".slider-range");
  elements.forEach(function (e) {
    initSlider(e);
  });
  var cardioSlider = new rSlider({
    target: "#cardio-exercise",
    values: [
      "<30min",
      "30min",
      "45min",
      "1h",
      "1.5h",
      "2h",
      "2.5h",
      "3h",
      "3.5h",
      "4h",
      "4.5h",
      "5+",
    ],
    range: false,
    set: ["<30min"],
    tooltip: false,
  });
};

var initSlider = function (element) {
  var slider = new rSlider({
    target: element,
    values: ["<1", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10+"],
    range: false,
    tooltip: false,
  });
};

var stepIndex = 1;
var infopage;
var radiopage;
var rangepage;
var outputpage;
var buildStepper = function () {
  infopage = document.getElementById("basic-info");
  radiopage = document.getElementById("yes-no");
  rangepage = document.getElementById("ranges-question");
  outputpage = document.getElementById("output");
  evaluateIndex();
};

var evaluateIndex = function () {
  if (stepIndex == 1) {
    infopage.style.display = "block";
    radiopage.style.display = "none";
    rangepage.style.display = "none";
    outputpage.style.display = "none";
  } else if (stepIndex == 2) {
    infopage.style.display = "none";
    radiopage.style.display = "block";
    rangepage.style.display = "none";
    outputpage.style.display = "none";
  } else if (stepIndex == 3) {
    infopage.style.display = "none";
    radiopage.style.display = "none";
    rangepage.style.display = "block";
    outputpage.style.display = "none";
    if (isSliderloaded == false) {
      setPage();
      isSliderloaded = true;
    }
  } else if (stepIndex == 4) {
    infopage.style.display = "none";
    radiopage.style.display = "none";
    rangepage.style.display = "none";
    outputpage.style.display = "block";
    document.getElementById("stepper").style.display = "none";
  }

  if (stepIndex != 4) {
    var linksWithDataIndex = document.querySelectorAll("a[data-index]");
    linksWithDataIndex.forEach(function (link) {
      var dataIndex = parseInt(link.getAttribute("data-index"), 10);

      if (dataIndex <= stepIndex) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }
  window.scrollTo(0, 0);
};
function backToInfo() {
  stepIndex = 1;
  evaluateIndex();
}
function backToRadios() {
  stepIndex = 2;
  evaluateIndex();
}
